export default "__VITE_ASSET__BNol2hwG__"